import { useFetch } from "@common/hooks/useFetch";
import { saveUserInformation } from "@utils/storage";
import { CREATE_PROSPECT_ROUTE,CREATE_CROSS_SELL_ROUTE } from "@api-routes";
import { getPayload, getResponseToState, IProspectResponse } from "@mappers/postProspectMapper";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const useCreateProspect = () => {
    const [createProspectState, { post }] = useFetch();

    const callCreateProspect = () => {
        
        return post<IProspectResponse>(keycloakUtils.isAuthenticated()?CREATE_CROSS_SELL_ROUTE:CREATE_PROSPECT_ROUTE, { body: getPayload(), isSecured: keycloakUtils.isAuthenticated() }).then(
            (prospectResponse) => {
                if (prospectResponse) {
                    const prospect = getResponseToState(prospectResponse);

                    if (prospect.prospectUuid) {
                        saveUserInformation(prospect.orderReference, prospect.prospectUuid);

                        return prospect;
                    }

                    return undefined;
                }

                return undefined;
            }
        );
        

    };

    return { callCreateProspect, createProspectState };
};
